class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.originalSubmitButton = document.querySelector(
      `#ProductSubmitButton-${this.dataset.sectionId}`
    );
    this.stickyButton = this.querySelector('.sticky-add-to-cart__button');
    this.form = this.querySelector('form');
  }

  connectedCallback() {
    if (!this.originalSubmitButton) return;

    // Trigger main form submit when sticky button is clicked
    if (this.stickyButton && this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        // Trigger the original add to cart instead to ensure everything works
        // (like quantity selector, variant selector, etc)
        if (this.originalSubmitButton) {
          this.originalSubmitButton.click();
        }
      });
    }

    // Set up intersection observer
    this.setupObserver();
  }

  setupObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const targetToObserve = this.originalSubmitButton;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // If the original button is intersecting (visible), hide the sticky bar
        if (entry.isIntersecting) {
          this.classList.remove('is-active');
        } else {
          // If the original button is not intersecting (scrolled past), show the sticky bar
          
          // Check if we specifically scrolled PAST the button (button is above viewport)
          // We can check entry.boundingClientRect.top < 0 to ensure it's above.
          // But usually just not intersecting is enough, as users want it when scrolling down.
          this.classList.add('is-active');
        }
      });
    }, observerOptions);

    observer.observe(targetToObserve);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
